// Imports
import { CircularProgress } from '@mui/material';
import './Elements.css';

// Full screen loader spinner
function FullScreenLoader() {
  return <div className="gbk-fs-loader">
    <div>
      <img className='gbk-fs-loader-logo' src='https://gobikes-prod-public.s3.ap-south-1.amazonaws.com/uploads/admin/site/d95fb648-07d3-473d-8804-bd9b72471e4f.png' alt='gowheelo-logo' />
    </div>
    <br /><br />
    <CircularProgress />
  </div>;
}

export { FullScreenLoader };